module.exports = __webpack_public_path__ + "img/keitaro-landing-step-3_1.ru.e1cd3a2f.jpg";